module.exports = __webpack_public_path__ + "static/media/012.c1eff5aa.jpg";